/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscribeSupport
 */
export interface SubscribeSupport {
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeSupport
     */
    create?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeSupport
     */
    update?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeSupport
     */
    _delete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeSupport
     */
    passThrough?: boolean;
}

/**
 * Check if a given object implements the SubscribeSupport interface.
 */
export function instanceOfSubscribeSupport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscribeSupportFromJSON(json: any): SubscribeSupport {
    return SubscribeSupportFromJSONTyped(json, false);
}

export function SubscribeSupportFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscribeSupport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'create': !exists(json, 'create') ? undefined : json['create'],
        'update': !exists(json, 'update') ? undefined : json['update'],
        '_delete': !exists(json, 'delete') ? undefined : json['delete'],
        'passThrough': !exists(json, 'passThrough') ? undefined : json['passThrough'],
    };
}

export function SubscribeSupportToJSON(value?: SubscribeSupport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'create': value.create,
        'update': value.update,
        'delete': value._delete,
        'passThrough': value.passThrough,
    };
}

